import React from 'react';

const HomeContext = React.createContext('ticket');
export const HomeProvider = HomeContext.Provider;

export default HomeContext;
